<h1>ABMP CE Pricing</h1>
<div id="ce-pricing-holder">
  <div id="ce-pricing">
    <p>Whether you’re looking for video-based courses of hands-on techniques, ethics continuing education to meet state
      requirements, or an exciting new topic to enhance your skills, you’ll find it in the ABMP Education Center!

      With more than 200 courses from your favorite presenters available on-demand, it’s time to start learning and
      earning CE. You can choose that one perfect course, save with multi-course purchases and course packages, or get
      it all by joining as an ABMP member!</p>
  </div>

  <h5 class="mb-5">200+ Courses = Best Value</h5>
  <div id="best-value">
    <div id="best-row" class="row">
      <div id="best-graphic">
        <div id="cart-marketing" class="card">
          <div class="card-header text-uppercase mb-1 text-center">
            <h3>ALL</h3>
          </div>
          <div class="card-subheader best-value highlited m-auto value">Best value</div>
          <div class="card-body">
            <h2 class="dark-blue mb-3">$199</h2>
            <p class=" text-center light-grey">ABMP membership includes 200+ courses with CE</p>
          </div>
        </div>
        <div class="text-center mt-4">
          <a href="https://www.abmp.com/signup?destination=learn"><button class="text-center background-blue join">Join now</button></a>
        </div>
      </div>
      <div id="best-info" class="col">
        <p class="text-left">Join ABMP for as low as $199 and gain access to 200+ courses with CE. </p>
        <p>
          <fa-icon class="mr-3 green" icon="check" size="sm"> </fa-icon> Exceptional liability insurance
          <br>
          <fa-icon class="mr-3 green" icon="check" size="sm"></fa-icon> ABMP Five-Minute Muscles
          <br>
          <fa-icon class="mr-3 green" icon="check" size="sm"></fa-icon>Pocket Pathology
          <br>
          <fa-icon class="mr-3 green" icon="check" size="sm"></fa-icon>50+ member discounts, and much more!
          <br>
          <fa-icon class="mr-3 green" icon="check" size="sm"></fa-icon>ABMP Certified membership, unlocks even more
          CE,
          with ebooks and access to 400 more CE hours. Plus, ABMP
          Certified members can choose to pay <strong>$20/month for membership</strong>.
        </p>

      </div>
    </div>
  </div>
  <h2>CE Purchase Options </h2>
  <p>Choose one course for $30 or purchase 5 or more courses at the same time and save! You can select your own
    courses
    or choose one of our curated course packages.</p>
  <div id="pick-courses">
    <div>
      <h3>Choose Your Own Courses
      </h3>
    </div>
    <div>

      <p>Click the “Add to Cart” button on a course page. Keep browsing the library and adding courses to your cart!
        When
        you’re ready to check out, click the cart icon at the top of the page. Your multi-course discount, if
        applicable,
        will be applied at checkout. You must purchase the courses at the same time for the discount to be applied.
      </p>


      <div class="row even mb-3">
        <div class="card" id="one-card">
          <div class="card-header text-center">
            <h3 class="dark-blue">ONE</h3>
          </div>
          <div class="card-body text-center">
            <h5 class="margin-2 light-grey">1 course with CE</h5>
            <h2 class="dark-blue">$30</h2>
          </div>
        </div>
        <div class="card" id="some-card">
          <div class="card-header text-center">
            <h3 class="dark-blue">SOME</h3>
          </div>
          <h5 class="text-center light-grey">Choose your own, or buy a package</h5>
          <div class="row" id="inner-some">
            <div class="card-body text-center dot">
              <h2 class="dark-blue">$99</h2>
              <h5 class="light-grey">5 courses with CE</h5>
            </div>
            <div class="card-body text-center">
              <h2 class="dark-blue">$149</h2>
              <h5 class="light-grey">10 courses with CE</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left border-sides mb-2 pb-5">
        <button class="background-blue pricing-button mb-5" (click)="toggleShowDiv('b')">Pricing Details
          <fa-icon *ngIf="activeFaq !=='b'" class="ml-4" icon="chevron-right" size="md">
          </fa-icon>
          <fa-icon *ngIf="activeFaq ==='b'" class="ml-4" icon="chevron-down" size="md">
          </fa-icon>
        </button>
        <div class="col text-left first-description dark-blue" id="pricing-details"
          [@slideInOut]="this.activeFaq=='b' ? 'in': 'out'">
          <p>
            1 course = $30
          </p>

          <p>5 courses = $99 ($51 savings)</p>
          <p>$51 savings is also applied to purchases of 6–9 courses</p>

          <p>10 courses = $149 ($151 savings)</p>
          <p>$151 savings is also applied to purchases of 11 or more courses</p>
        </div>

      </div>
    </div>
  </div>
  <div id="packaged-courses">
    <div>
      <h3>Course Packages</h3>
    </div>
    <div>
      <p>ABMP has created course packages to make it easy for you to purchase multiple courses at once, receive your
        multi-course discount, and start learning and earning CE right away!
      </p>
      <p>
        Visit your <a [routerLink]="['/packages']">My Packages</a> page to access the course packages you have already
        purchased and discover course
        packages that are available for you to buy.
      </p>
    </div>

    <h3>FAQs</h3>
    <app-dynamic-content blocktitle="Pricing FAQs"></app-dynamic-content>
  </div>